import { Button, Typography } from "@material-ui/core"
import * as api from "api"
import NextLink from "common/bit/NextLink"
import slugify from "common/bit/utils/slugify"
import { Desktop, Mobile } from "common/MediaQueries"
import { memo, useEffect, useRef } from "react"
import styled from "styled-components"
import { StyledRow } from "theme/shared"
import CardRowText from "../CardRowText"

const StyledWrapper = styled.div<{ $selected: boolean }>`
  margin: 0px 0px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: ${(p) => p.theme.colors.white};
  padding: 20px 15px;
  border-radius: 6px;
  border: 1.5px solid
    ${(p) =>
      p.$selected ? p.theme.colors.saphire : p.theme.colors.transparent};
`
const StyledHeadline = styled(Typography).attrs({ variant: "h3" })`
  margin-top: 0;
  display: inline-block;
`
const StyledButtonWrap = styled.div`
  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-grow: 1;
  }
`
const StyledButton = styled(Button)`
  width: 100%;
`

type ShowRoomItemItemProps = {
  serviceCenter: api.SingleServiceCenter
  isServiceCenterSelected: boolean
}

const ServiceCentersItem = ({
  serviceCenter,
  isServiceCenterSelected,
}: ShowRoomItemItemProps) => {
  const serviceCenterRef = useRef(null)

  // Scroll to Service Center Card in right sidebar
  // when User clicks on a map marker
  useEffect(() => {
    if (isServiceCenterSelected && serviceCenter) {
      serviceCenterRef.current.scrollIntoView(false)
    }
  })

  const link = `/service-center/[serviceCenterId]/[serviceCenterSlug]`
    .replace("[serviceCenterId]", serviceCenter.id.toString())
    .replace("[serviceCenterSlug]", slugify(serviceCenter.name))

  return (
    <StyledWrapper ref={serviceCenterRef} $selected={isServiceCenterSelected}>
      <StyledHeadline>
        <NextLink href={link}>{serviceCenter?.name}</NextLink>
      </StyledHeadline>
      <CardRowText
        data={serviceCenter?.address}
        iconName="mazdaLocationIcon"
        imageAlt="location-מיקום"
      />
      <CardRowText
        data={serviceCenter.whatsapp}
        link={serviceCenter.whatsappLink}
        iconName="whatsappLogo"
      />
      <CardRowText
        data={serviceCenter.phone}
        link={`tel:${serviceCenter.phone}`}
        iconName="phoneCall"
        imageAlt="phone-טלפון"
      />
      <Desktop>
        <CardRowText
          data={serviceCenter?.fax}
          iconName="fax"
          imageAlt="fax-פקס"
        />
      </Desktop>
      <StyledRow $gap="10px" $fullWidth>
        <Mobile>
          {serviceCenter.wazeLink && (
            <StyledButtonWrap>
              <NextLink href={serviceCenter.wazeLink} passHref openInNewTab>
                <StyledButton variant="outlined" fullWidth>
                  ניווט ב-Waze
                </StyledButton>
              </NextLink>
            </StyledButtonWrap>
          )}
        </Mobile>
        <StyledButtonWrap>
          <NextLink passHref href={link}>
            <StyledButton variant="outlined" fullWidth>
              לתיאום הגעה
            </StyledButton>
          </NextLink>
        </StyledButtonWrap>
      </StyledRow>
    </StyledWrapper>
  )
}

export default memo(ServiceCentersItem)
